import { render, staticRenderFns } from "./Step4Signatory.vue?vue&type=template&id=38b9fc33&scoped=true"
import script from "./Step4Signatory.vue?vue&type=script&lang=js"
export * from "./Step4Signatory.vue?vue&type=script&lang=js"
import style0 from "./Step4Signatory.vue?vue&type=style&index=0&id=38b9fc33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9fc33",
  null
  
)

export default component.exports